import WelcomePage from '@/pages/WelcomePage';
import { CateringPage, CateringSettings } from '@/pages/Catering';
import WeeklyMenuPage from '@/pages/WeeklyMenuPage';
import SettingsPage from '@/pages/SettingsPage';
import ReportsPage from '@/pages/ReportsPage';
import AdminPage from '@/pages/AdminPage';
import Page404 from '@/pages/Page404';
import CallbackAuth0Page from '@/pages/CallbackAuth0Page';
import { ROUTE_NAMES, ROUTES, Role } from '@/constants';

export default [
  {
    path: '/',
    component: WelcomePage,
    name: ROUTE_NAMES.WELCOME_PAGE,
    meta: {},
  },
  {
    path: '/settings',
    component: SettingsPage,
    name: ROUTE_NAMES.SETTINGS,
    meta: {
      requiresAuth: true,
      authorizedRoles: [Role.ADMIN, Role.COMMON],
    },
  },
  {
    path: '/reports',
    component: ReportsPage,
    name: ROUTE_NAMES.REPORTS,
    meta: {
      requiresAuth: true,
      authorizedRoles: [Role.ADMIN, Role.COMMON],
    },
  },
  {
    path: '/menu/:week?',
    component: WeeklyMenuPage,
    name: ROUTE_NAMES.WEEKLY_MENU,
    meta: {
      requiresAuth: true,
      authorizedRoles: [Role.ADMIN, Role.COMMON],
    },
  },
  {
    path: '/admin/:week?',
    name: ROUTE_NAMES.ADMIN,
    component: AdminPage,
    meta: {
      requiresAuth: true,
      authorizedRoles: [Role.ADMIN],
    },
  },
  {
    path: ROUTES.CATERING,
    name: ROUTE_NAMES.CATERING_LANDING,
    component: CateringPage,
    meta: {
      requiresAuth: true,
      authorizedRoles: [Role.CATERING],
    },
  },
  {
    path: ROUTES.CATERING_SETTINGS,
    name: ROUTE_NAMES.CATERING_SETTINGS,
    component: CateringSettings,
    meta: {
      requiresAuth: true,
      authorizedRoles: [Role.CATERING],
    },
  },
  {
    path: '/callback',
    name: ROUTE_NAMES.AUTH0_CALLBACK,
    component: CallbackAuth0Page,
    meta: {},
  },
  {
    path: '*',
    name: '404',
    component: Page404,
  },
  {
    path: '/login',
    redirect: '/',
  },
];



// WEBPACK FOOTER //
// ./src/router/routes.js